import React from "react";
import { Button, Card, Form, Spinner } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";

/**
 * Мобільний / вузький екран: один співробітник = одна картка (дзеркало рядка таблиці).
 */
export default function SalariesEmployeeCard({
    r,
    serverFinalized,
    paidSaving,
    tgModalBusy,
    tgSendActiveEmployeeId,
    tgRevokingId,
    updateLineLocal,
    toggleLinePaid,
    openSalaryTelegramSendModal,
    revokeLastSalaryTelegram,
    employeeDisplayName,
    formatMoney,
    formatTgSentAt,
}) {
    const paid = !!r.line.paid;
    return (
        <Card className={`mb-3 shadow-sm ${paid ? "border-success border-2" : ""}`}>
            <Card.Body className="p-3">
                <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                    <div>
                        <Card.Title className="h6 mb-0">{employeeDisplayName(r.employee)}</Card.Title>
                        {r.employee.linkedName && (
                            <div className="small text-muted">профіль: {r.employee.displayName}</div>
                        )}
                        {r.employee.groupLabel ? (
                            <div className="small text-muted">{r.employee.groupLabel}</div>
                        ) : null}
                    </div>
                    <Button
                        variant={paid ? "outline-secondary" : "outline-success"}
                        size="sm"
                        className="flex-shrink-0"
                        disabled={serverFinalized || paidSaving}
                        onClick={() => toggleLinePaid(r.employee._id, !paid)}
                    >
                        {paid ? "Скасувати" : "Оплачено"}
                    </Button>
                </div>

                <div className="row g-2 small">
                    <div className="col-6">
                        <Form.Label className="small text-muted mb-0">ТО для %</Form.Label>
                        <Form.Control
                            type="number"
                            min={0}
                            disabled={serverFinalized}
                            value={r.line.turnoverForCommission}
                            onChange={(e) =>
                                updateLineLocal(r.employee._id, { turnoverForCommission: e.target.value })
                            }
                            size="sm"
                        />
                    </div>
                    <div className="col-6">
                        <Form.Label className="small text-muted mb-0">Зміни</Form.Label>
                        <Form.Control
                            type="number"
                            min={0}
                            disabled={serverFinalized}
                            value={r.line.shifts}
                            onChange={(e) => updateLineLocal(r.employee._id, { shifts: e.target.value })}
                            size="sm"
                        />
                    </div>
                    <div className="col-6">
                        <Form.Label className="small text-muted mb-0">Відпустка, дн</Form.Label>
                        <Form.Control
                            type="number"
                            min={0}
                            disabled={serverFinalized}
                            value={r.line.vacationDays}
                            onChange={(e) => updateLineLocal(r.employee._id, { vacationDays: e.target.value })}
                            size="sm"
                        />
                    </div>
                    <div className="col-6">
                        <Form.Label className="small text-muted mb-0">Премія</Form.Label>
                        <Form.Control
                            type="number"
                            disabled={serverFinalized}
                            value={r.line.bonus}
                            onChange={(e) => updateLineLocal(r.employee._id, { bonus: e.target.value })}
                            size="sm"
                        />
                    </div>
                    <div className="col-6">
                        <Form.Label className="small text-muted mb-0">Штраф</Form.Label>
                        <Form.Control
                            type="number"
                            disabled={serverFinalized}
                            value={r.line.penalty}
                            onChange={(e) => updateLineLocal(r.employee._id, { penalty: e.target.value })}
                            size="sm"
                        />
                    </div>
                    <div className="col-12">
                        <Form.Label className="small text-muted mb-0">Комісія вручну (порожньо = авто)</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="авто"
                            disabled={serverFinalized}
                            value={r.line.commissionAmountOverride == null ? "" : r.line.commissionAmountOverride}
                            onChange={(e) =>
                                updateLineLocal(r.employee._id, {
                                    commissionAmountOverride: e.target.value === "" ? null : e.target.value,
                                })
                            }
                            size="sm"
                        />
                    </div>
                </div>

                <hr className="my-2" />
                <div className="small row g-1">
                    <div className="col-6">
                        Комісія: <strong>{r.computed.commission}</strong>
                    </div>
                    <div className="col-6">
                        Зміни грн: <strong>{r.computed.shiftPay}</strong>
                    </div>
                    <div className="col-6">
                        Відпускні грн: <strong>{r.computed.vacationPay}</strong>
                    </div>
                    <div className="col-12">
                        Нараховано: <strong>{r.computed.accrued}</strong>
                    </div>
                    <div className="col-12">
                        Аванс:{" "}
                        {r.employee.hasAdvance === false ? (
                            "—"
                        ) : (
                            <>
                                {r.computed.advance}{" "}
                                <span className="text-muted">({r.employee.advanceDayOfMonth}-го)</span>
                            </>
                        )}
                    </div>
                    <div className="col-12">
                        До виплати {r.employee.salaryDayOfMonth}-го:{" "}
                        {paid ? (
                            <>
                                <span className="text-muted text-decoration-line-through">
                                    {r.computed.payOnSalaryDay}
                                </span>{" "}
                                <span className="text-success fw-semibold">у залишку 0</span>
                            </>
                        ) : (
                            <strong className="text-success">{formatMoney(r.computed.payOnSalaryDay)}</strong>
                        )}
                    </div>
                </div>

                <div className="d-flex flex-wrap gap-2 mt-3">
                    <Button
                        variant="outline-primary"
                        size="sm"
                        disabled={
                            !r.employee.linkedTelegramId || Boolean(tgModalBusy) || Boolean(tgRevokingId) || paidSaving
                        }
                        onClick={() => openSalaryTelegramSendModal(r.employee._id)}
                    >
                        {tgSendActiveEmployeeId &&
                        String(tgSendActiveEmployeeId) === String(r.employee._id) ? (
                            <Spinner animation="border" size="sm" />
                        ) : (
                            "Надіслати в Telegram"
                        )}
                    </Button>
                    <Button
                        variant="outline-danger"
                        size="sm"
                        className="d-inline-flex align-items-center justify-content-center px-2"
                        disabled={
                            !r.canRevokeLastSalaryTelegram ||
                            Boolean(tgModalBusy) ||
                            Boolean(tgRevokingId) ||
                            paidSaving
                        }
                        title={
                            r.canRevokeLastSalaryTelegram
                                ? "Видалити останнє з надісланих у Telegram (LIFO)"
                                : "Спочатку надішліть розрахунок кнопкою «Надіслати в Telegram»"
                        }
                        aria-label="Видалити останнє повідомлення ЗП у Telegram"
                        onClick={() => revokeLastSalaryTelegram(r.employee._id)}
                    >
                        {tgRevokingId === r.employee._id ? (
                            <Spinner animation="border" size="sm" />
                        ) : (
                            <Trash size={16} aria-hidden />
                        )}
                    </Button>
                </div>
                {r.salaryTelegramMeta?.lastSentAt ? (
                    <div className="small text-muted mt-2">
                        Останнє повідомл.: {formatTgSentAt(r.salaryTelegramMeta.lastSentAt)}
                        {r.salaryTelegramMeta.sentCount > 1
                            ? ` · у стеку ${r.salaryTelegramMeta.sentCount}`
                            : ""}
                    </div>
                ) : null}

                <div className="mt-2">
                    <Form.Label className="small text-muted mb-0">Нотатка</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={2}
                        disabled={serverFinalized}
                        value={r.line.notes}
                        onChange={(e) => updateLineLocal(r.employee._id, { notes: e.target.value })}
                        size="sm"
                    />
                </div>
            </Card.Body>
        </Card>
    );
}
